<template>
  <section class="rendora-start-right-now" data-buried="StartRightNow">
    <div class="rendora-start-right-now__background-container">
      <div
        ref="bgImgRef"
        v-intersect.once="handleBgImgIntersect"
        class="rendora-start-right-now__bg-image"
        :data-src="BgImg"
      ></div>
      <div
        ref="bgAvatarRef"
        v-intersect.once="handleBgAvatarIntersect"
        class="rendora-start-right-now__avatar-image"
        :data-src="BgAvatar"
      ></div>
    </div>
    <h2 class="rendora-start-right-now__title pc-only">
      Start your
      <span class="noto">3D AI Avatar Video</span>
      Generation
      <span class="noto">Right Now</span>
    </h2>
    <h2 class="rendora-start-right-now__title m-only">
      Start your
      <span class="noto">3D AI Avatar Video</span>
      <br />
      Generation
      <span class="noto">Right Now</span>
    </h2>
    <div class="rendora-start-right-now__operation">
      <ArrowBtn
        class="rendora-start-right-now__start-btn"
        variant="black-common"
        text="Get Started for Free"
        @click="$emit('trial')"
      />
      <BaseBtn
        class="rendora-start-right-now__book-btn"
        variant="white-common"
        @click="$emit('consult')"
      >
        <span>Book a Demo</span>
      </BaseBtn>
    </div>
  </section>
</template>

<script lang="ts" setup>
import ArrowBtn from '~/design/components/buttons/arrow-btn.vue';
import BaseBtn from '~/design/components/buttons/base.vue';
import { transformImage } from '~/utils/';
import { getFeUrl } from '~/utils/url';

const BgImg = transformImage(
  getFeUrl('/rendora/main/start-right-now/bg-3.png?x-oss-process=image/format,webp'),
);
const BgAvatar = transformImage(
  getFeUrl('/rendora/main/start-right-now/being-2.png?x-oss-process=image/format,webp'),
);

const bgImgRef = ref<HTMLDivElement>();
const bgAvatarRef = ref<HTMLDivElement>();

const handleBgImgIntersect = () => {
  if (bgImgRef.value) {
    bgImgRef.value.style.backgroundImage = `url(${BgImg})`;
  }
};

const handleBgAvatarIntersect = () => {
  if (bgAvatarRef.value) {
    bgAvatarRef.value.style.backgroundImage = `url(${BgAvatar})`;
  }
};
</script>

<style lang="scss" scoped src="./en-styles/mobile.scss" />
<style lang="scss" scoped src="./en-styles/pc.scss" />
